import { useState, useEffect, useRef } from "react";
import toast from "../../../utils/toast";
import {
  getNotificationTemplateSms,
  getNotificationTemplateEvent,
  getNotificationTemplateEventVariable,
  getNotificationTemplateById,
  insertUpdateNotificationTemplate,
  deleteNotificationTemplate,
  toggleNotificationTemplate,
  getCommunicationSettingsSms,
  getCommunicationSettingsSmsById,
  insertUpdateCommunicationSettingsSms,
  deleteCommunicationSettingsSmsById,
  toggleCommunicationSettingsSmsById,
  getReplacementVariableforSmsAndWhatsapp,
} from "../../../services/propertyOwner/propertyOwnerServices";

export default function OwnerSmsApi() {
  const [templateEvents, setTemplateEvents] = useState([]);
  const [smsTemplates, setSmsTemplates] = useState([]);
  const [smsTemplatesLoading, setSmsTemplatesLoading] = useState(true);
  const [smsTemplateVariables, setSmsTemplateVariables] = useState([]);
  const [deleteSmsTplId, setDeleteSmsTplId] = useState(null);
  const [deleteSmsTplLoading, setDeleteSmsTplLoading] = useState(false);
  const [previewSmsTpl, setPreviewSmsTpl] = useState(null);
  const [togglingId, setTogglingId] = useState(null);

  const [addSmsTplOpen, setAddSmsTplOpen] = useState(false);
  const [addSmsTplForm, setAddSmsTplForm] = useState({
    eventId: "",
    templateName: "",
    bodyText: "",
    isActive: true,
    sortOrder: 0,
  });
  const [addSmsTplErrors, setAddSmsTplErrors] = useState({});
  const [addSmsTplLoading, setAddSmsTplLoading] = useState(false);

  const [editSmsTplOpen, setEditSmsTplOpen] = useState(false);
  const [editSmsTplId, setEditSmsTplId] = useState(null);
  const [editSmsTplForm, setEditSmsTplForm] = useState({});
  const [editSmsTplErrors, setEditSmsTplErrors] = useState({});
  const [editSmsTplLoading, setEditSmsTplLoading] = useState(false);
  const [editSmsTplFetching, setEditSmsTplFetching] = useState(false);

  const [smsApiList, setSmsApiList] = useState([]);
  const [smsApiLoading, setSmsApiLoading] = useState(true);

  const [systemVars, setSystemVars] = useState([]);
  const [apiTogglingId, setApiTogglingId] = useState(null);
  const [deleteApiId, setDeleteApiId] = useState(null);
  const [deleteApiLoading, setDeleteApiLoading] = useState(false);

  const [addApiOpen, setAddApiOpen] = useState(false);
  const [addApiForm, setAddApiForm] = useState({
    name: "",
    apiUrl: "",
    methodType: "POST",
    responseType: "JSON",
    headers: [{ key: "", value: "" }],
    scheduleDate: "",
    scheduleTime: "",
    isActive: true,
    sortOrder: 0,
  });
  const [addApiErrors, setAddApiErrors] = useState({});
  const [addApiLoading, setAddApiLoading] = useState(false);
  const addBodyRef = useRef(null);

  const [editApiOpen, setEditApiOpen] = useState(false);
  const [editApiId, setEditApiId] = useState(null);
  const [editApiForm, setEditApiForm] = useState({});
  const [editApiErrors, setEditApiErrors] = useState({});
  const [editApiLoading, setEditApiLoading] = useState(false);
  const [editApiFetching, setEditApiFetching] = useState(false);
  const editBodyRef = useRef(null);

  useEffect(() => {
    fetchSmsApiList();
    fetchSmsTemplates();
  }, []);

  useEffect(() => {
    if (
      !editApiFetching &&
      editApiOpen &&
      editBodyRef.current &&
      editApiForm.requestBodyJson !== undefined
    ) {
      editBodyRef.current.value = editApiForm.requestBodyJson || "";
    }
  }, [editApiFetching]);

  const fetchSmsApiList = async () => {
    setSmsApiLoading(true);
    try {
      const res = await getCommunicationSettingsSms();
      if (res.statusCode === 1) setSmsApiList(res.data || []);
    } catch {
      console.log("Failed to load SMS API list");
    } finally {
      setSmsApiLoading(false);
    }
  };

  const fetchTemplateEvents = async () => {
    try {
      const res = await getNotificationTemplateEvent();
      if (res.statusCode === 1) setTemplateEvents(res.data || []);
    } catch {
      console.log("Failed to load events");
    }
  };

  const fetchSmsTemplates = async () => {
    setSmsTemplatesLoading(true);
    try {
      const res = await getNotificationTemplateSms();
      if (res.statusCode === 1) setSmsTemplates(res.data || []);
    } catch {
      console.log("Failed to load SMS templates");
    } finally {
      setSmsTemplatesLoading(false);
    }
  };

  const fetchSmsVariables = async (eventId) => {
    if (!eventId) {
      setSmsTemplateVariables([]);
      return;
    }
    try {
      const res = await getNotificationTemplateEventVariable(eventId);
      if (res.statusCode === 1) setSmsTemplateVariables(res.data || []);
    } catch {
      console.log("Failed to load variables");
    }
  };

  const openAddSmsTplModal = () => {
    setAddSmsTplForm({
      eventId: "",
      templateName: "",
      bodyText: "",
      isActive: true,
      sortOrder: 0,
    });
    setAddSmsTplErrors({});
    setSmsTemplateVariables([]);
    fetchTemplateEvents();
    setAddSmsTplOpen(true);
  };

  const handleAddSmsTplEventChange = (eventId) => {
    const selectedEvent = templateEvents.find(
      (ev) => ev.eventId === Number(eventId),
    );
    setAddSmsTplForm((p) => ({
      ...p,
      eventId,
      templateName: selectedEvent ? selectedEvent.eventName : "",
    }));
    setAddSmsTplErrors((p) => ({ ...p, eventId: "" }));
    fetchSmsVariables(eventId);
  };

  const handleAddSmsTplSubmit = async () => {
    const e = {};
    if (!addSmsTplForm.eventId) e.eventId = "Required";
    if (!addSmsTplForm.bodyText.trim()) e.bodyText = "Required";
    if (Object.keys(e).length) {
      setAddSmsTplErrors(e);
      return;
    }
    setAddSmsTplLoading(true);
    try {
      const payload = {
        id: 0,
        eventId: Number(addSmsTplForm.eventId),
        channel: "SMS",
        templateName: addSmsTplForm.templateName,
        subject: "",
        bodyText: addSmsTplForm.bodyText,
        isHtml: false,
        isActive: addSmsTplForm.isActive,
        sortOrder: Number(addSmsTplForm.sortOrder),
        extraFieldsJson: "",
      };
      const res = await insertUpdateNotificationTemplate(payload);
      if (res.statusCode === 1) {
        toast.success(res.message);
        setAddSmsTplOpen(false);
        fetchSmsTemplates();
      } else toast.error(res.message);
    } catch {
      toast.error("Failed to create template");
    } finally {
      setAddSmsTplLoading(false);
    }
  };

  const openEditSmsTplModal = async (id) => {
    setEditSmsTplId(id);
    setEditSmsTplErrors({});
    setEditSmsTplFetching(true);
    setEditSmsTplOpen(true);
    fetchTemplateEvents();
    try {
      const res = await getNotificationTemplateById(id);
      if (res.statusCode === 1) {
        const d = res.data;
        setEditSmsTplForm({
          eventId: d.eventId || "",
          templateName: d.templateName || "",
          bodyText: d.bodyText || "",
          isActive: d.isActive,
          sortOrder: d.sortOrder || 0,
        });
        fetchSmsVariables(d.eventId);
      } else {
        toast.error(res.message);
        setEditSmsTplOpen(false);
      }
    } catch {
      toast.error("Failed to load template");
      setEditSmsTplOpen(false);
    } finally {
      setEditSmsTplFetching(false);
    }
  };

  const handleEditSmsTplEventChange = (eventId) => {
    const selectedEvent = templateEvents.find(
      (ev) => ev.eventId === Number(eventId),
    );
    setEditSmsTplForm((p) => ({
      ...p,
      eventId,
      templateName: selectedEvent ? selectedEvent.eventName : p.templateName,
    }));
    fetchSmsVariables(eventId);
  };

  const handleEditSmsTplSubmit = async () => {
    const e = {};
    if (!editSmsTplForm.eventId) e.eventId = "Required";
    if (!editSmsTplForm.bodyText.trim()) e.bodyText = "Required";
    if (Object.keys(e).length) {
      setEditSmsTplErrors(e);
      return;
    }
    setEditSmsTplLoading(true);
    try {
      const payload = {
        id: editSmsTplId,
        eventId: Number(editSmsTplForm.eventId),
        channel: "SMS",
        templateName: editSmsTplForm.templateName,
        subject: "",
        bodyText: editSmsTplForm.bodyText,
        isHtml: false,
        isActive: editSmsTplForm.isActive,
        sortOrder: Number(editSmsTplForm.sortOrder),
        extraFieldsJson: "",
      };
      const res = await insertUpdateNotificationTemplate(payload);
      if (res.statusCode === 1) {
        toast.success(res.message);
        setEditSmsTplOpen(false);
        fetchSmsTemplates();
      } else toast.error(res.message);
    } catch {
      toast.error("Failed to update template");
    } finally {
      setEditSmsTplLoading(false);
    }
  };

  const handleDeleteSmsTemplate = async () => {
    setDeleteSmsTplLoading(true);
    try {
      const res = await deleteNotificationTemplate(deleteSmsTplId);
      if (res.statusCode === 1) {
        toast.success(res.message);
        setDeleteSmsTplId(null);
        fetchSmsTemplates();
      } else toast.error(res.message);
    } catch {
      toast.error("Failed to delete template");
    } finally {
      setDeleteSmsTplLoading(false);
    }
  };

  const handleToggleSmsTemplate = async (id) => {
    setTogglingId(id);
    try {
      const res = await toggleNotificationTemplate(id);
      if (res.statusCode === 1) {
        toast.success(res.message);
        setSmsTemplates((prev) =>
          prev.map((t) =>
            t.templateId === id ? { ...t, isActive: !t.isActive } : t,
          ),
        );
      } else toast.error(res.message);
    } catch {
      console.log("Failed to toggle");
    } finally {
      setTogglingId(null);
    }
  };

  const fetchSystemVars = async () => {
    try {
      const res = await getReplacementVariableforSmsAndWhatsapp();
      if (res.statusCode === 1) setSystemVars(res.data || []);
    } catch {
      console.log("Failed to load system vars");
    }
  };

  const parseHeaders = (headersJson) => {
    try {
      const obj = JSON.parse(headersJson || "{}");
      const entries = Object.entries(obj);
      return entries.length > 0
        ? entries.map(([key, value]) => ({ key, value }))
        : [{ key: "", value: "" }];
    } catch {
      return [{ key: "", value: "" }];
    }
  };

  const headersToJson = (headers) => {
    const obj = {};
    headers.forEach(({ key, value }) => {
      if (key.trim()) obj[key.trim()] = value;
    });
    return JSON.stringify(obj);
  };

  const insertVarToBody = (varName, ref, setForm) => {
    const el = ref.current;
    if (!el) return;
    const start = el.selectionStart;
    const end = el.selectionEnd;
    const val = el.value;
    const newVal = val.substring(0, start) + varName + val.substring(end);
    el.value = newVal;
    el.selectionStart = el.selectionEnd = start + varName.length;
    el.focus();
  };

  const openAddApiModal = () => {
    setAddApiForm({
      name: "",
      apiUrl: "",
      methodType: "POST",
      responseType: "JSON",
      headers: [{ key: "", value: "" }],
      scheduleDate: "",
      scheduleTime: "",
      isActive: true,
      sortOrder: 0,
    });
    setAddApiErrors({});
    fetchSystemVars();
    setAddApiOpen(true);
    setTimeout(() => {
      if (addBodyRef.current) addBodyRef.current.value = "";
    }, 0);
  };

  const handleAddApiSubmit = async () => {
    const e = {};
    if (!addApiForm.name.trim()) e.name = "Required";
    if (!addApiForm.apiUrl.trim()) e.apiUrl = "Required";
    if (Object.keys(e).length) {
      setAddApiErrors(e);
      return;
    }
    setAddApiLoading(true);
    try {
      const payload = {
        id: 0,
        isWhatsApp: false,
        name: addApiForm.name,
        apiUrl: addApiForm.apiUrl,
        methodType: addApiForm.methodType,
        responseType: addApiForm.responseType,
        headersJson: headersToJson(addApiForm.headers),
        requestBodyJson: addBodyRef.current?.value || "",
        scheduleDate: addApiForm.scheduleDate
          ? new Date(addApiForm.scheduleDate).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            })
          : null,
        scheduleTime: addApiForm.scheduleTime || null,
        isActive: addApiForm.isActive,
        sortOrder: Number(addApiForm.sortOrder),
      };
      const res = await insertUpdateCommunicationSettingsSms(payload);
      if (res.statusCode === 1) {
        toast.success(res.message);
        setAddApiOpen(false);
        fetchSmsApiList();
      } else toast.error(res.message);
    } catch {
      toast.error("Failed to save");
    } finally {
      setAddApiLoading(false);
    }
  };

  const openEditApiModal = async (id) => {
    setEditApiId(id);
    setEditApiErrors({});
    setEditApiFetching(true);
    setEditApiOpen(true);
    fetchSystemVars();
    try {
      const res = await getCommunicationSettingsSmsById(id);
      if (res.statusCode === 1) {
        const d = res.data;
        setEditApiForm({
          name: d.name || "",
          apiUrl: d.apiUrl || "",
          methodType: d.methodType || "POST",
          responseType: d.responseType || "JSON",
          headers: parseHeaders(d.headersJson),
          requestBodyJson: d.requestBodyJson || "",
          scheduleDate: d.scheduleDate
            ? new Date(d.scheduleDate).toISOString().split("T")[0]
            : "",
          scheduleTime: d.scheduleTime ? d.scheduleTime.substring(0, 5) : "",
          isActive: d.isActive,
          sortOrder: d.sortOrder || 0,
        });
      } else {
        toast.error(res.message);
        setEditApiOpen(false);
      }
    } catch {
      toast.error("Failed to load");
      setEditApiOpen(false);
    } finally {
      setEditApiFetching(false);
    }
  };

  const handleEditApiSubmit = async () => {
    const e = {};
    if (!editApiForm.name.trim()) e.name = "Required";
    if (!editApiForm.apiUrl.trim()) e.apiUrl = "Required";
    if (Object.keys(e).length) {
      setEditApiErrors(e);
      return;
    }
    setEditApiLoading(true);
    try {
      const payload = {
        id: editApiId,
        isWhatsApp: false,
        name: editApiForm.name,
        apiUrl: editApiForm.apiUrl,
        methodType: editApiForm.methodType,
        responseType: editApiForm.responseType,
        headersJson: headersToJson(editApiForm.headers),
        requestBodyJson: editBodyRef.current?.value || "",
        scheduleDate: editApiForm.scheduleDate
          ? new Date(editApiForm.scheduleDate).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            })
          : null,
        scheduleTime: editApiForm.scheduleTime || null,
        isActive: editApiForm.isActive,
        sortOrder: Number(editApiForm.sortOrder),
      };
      const res = await insertUpdateCommunicationSettingsSms(payload);
      if (res.statusCode === 1) {
        toast.success(res.message);
        setEditApiOpen(false);
        fetchSmsApiList();
      } else toast.error(res.message);
    } catch {
      toast.error("Failed to update");
    } finally {
      setEditApiLoading(false);
    }
  };

  const handleDeleteApi = async () => {
    setDeleteApiLoading(true);
    try {
      const res = await deleteCommunicationSettingsSmsById(deleteApiId);
      if (res.statusCode === 1) {
        toast.success(res.message);
        setDeleteApiId(null);
        fetchSmsApiList();
      } else toast.error(res.message);
    } catch {
      toast.error("Failed to delete");
    } finally {
      setDeleteApiLoading(false);
    }
  };

  const handleToggleApi = async (id) => {
    setApiTogglingId(id);
    try {
      const res = await toggleCommunicationSettingsSmsById(id);
      if (res.statusCode === 1) {
        toast.success(res.message);
        setSmsApiList((prev) =>
          prev.map((a) =>
            a.smsApiId === id ? { ...a, isActive: !a.isActive } : a,
          ),
        );
      } else toast.error(res.message);
    } catch {
      console.log("Failed to toggle");
    } finally {
      setApiTogglingId(null);
    }
  };

  return (
    <>
      <div className="main">
        <div className="topbar">
          <div>
            <div className="page-title" id="page-title">
              SMS API
            </div>
            <div className="page-sub" id="page-sub">
              API Settings › SMS Configuration
            </div>
          </div>
          <div className="topbar-right" id="topbar-right" />
        </div>
        <div className="content" id="content-area">
          <div
            style={{
              gridTemplateColumns: "230px 1fr",

              gap: 16,
              alignItems: "start",
            }}
          >
            <div></div>
            <div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: 14,
                }}
              >
                <div>
                  <div style={{ fontSize: 15, fontWeight: 700 }}>
                    📱 SMS API Form
                  </div>
                  <div
                    style={{
                      fontSize: 11,
                      color: "var(--text-secondary)",
                      marginTop: 2,
                    }}
                  >
                    Configure API endpoints for sending SMS messages
                  </div>
                </div>
                <button className="btn btn-primary" onClick={openAddApiModal}>
                  + Add New API
                </button>
              </div>

              {smsApiLoading ? (
                Array.from({ length: 2 }).map((_, i) => (
                  <div
                    key={i}
                    style={{
                      background: "var(--bg-secondary)",
                      border: "0.5px solid var(--border-light)",
                      borderRadius: "var(--radius-md)",
                      padding: 14,
                      marginBottom: 10,
                    }}
                  >
                    {Array.from({ length: 3 }).map((_, j) => (
                      <div
                        key={j}
                        style={{
                          height: 13,
                          borderRadius: 6,
                          background:
                            "linear-gradient(90deg, var(--bg-secondary) 25%, var(--border-light) 50%, var(--bg-secondary) 75%)",
                          backgroundSize: "200% 100%",
                          animation: "shimmer 1.4s infinite",
                          width: j === 0 ? "40%" : "70%",
                          marginBottom: 8,
                        }}
                      />
                    ))}
                  </div>
                ))
              ) : smsApiList.length === 0 ? (
                <div
                  style={{
                    textAlign: "center",
                    padding: "24px 0",
                    color: "var(--text-secondary)",
                    fontSize: 13,
                  }}
                >
                  No SMS API configured yet.
                </div>
              ) : (
                smsApiList.map((api) => (
                  <div
                    key={api.smsApiId}
                    style={{
                      background: "var(--bg-secondary)",
                      border: "0.5px solid var(--border-light)",
                      borderRadius: "var(--radius-md)",
                      padding: 14,
                      display: "flex",
                      alignItems: "flex-start",
                      gap: 12,
                      marginBottom: 10,
                    }}
                  >
                    <div style={{ flex: 1 }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                          marginBottom: 5,
                          flexWrap: "wrap",
                        }}
                      >
                        <span style={{ fontSize: 13, fontWeight: 600 }}>
                          {api.name}
                        </span>
                        {api.isDefault && (
                          <span className="badge badge-teal">Default</span>
                        )}
                        <span
                          className={`badge ${api.isActive ? "badge-active" : "badge-gray"}`}
                        >
                          {api.isActive ? "Active" : "Inactive"}
                        </span>
                        <span className="badge badge-info">
                          {api.methodType}
                        </span>
                        <span className="badge badge-gray">
                          {api.responseType}
                        </span>
                      </div>
                      <div
                        style={{
                          fontSize: 11,
                          color: "var(--text-secondary)",
                          fontFamily: "monospace",
                          wordBreak: "break-all",
                          lineHeight: "1.6",
                        }}
                      >
                        {api.apiUrl}
                      </div>
                      {api.headersJson && api.headersJson !== "{}" && (
                        <div
                          style={{
                            marginTop: 5,
                            fontSize: 10,
                            color: "var(--text-tertiary)",
                          }}
                        >
                          Headers configured
                        </div>
                      )}
                    </div>
                    <div style={{ display: "flex", gap: 5, flexShrink: 0 }}>
                      {/* <button className="btn btn-xs">Edit</button>
                      <button
                        className={`btn btn-xs ${api.isActive ? "btn-danger" : "btn-success"}`}
                      >
                        {api.isActive ? "Deactivate" : "Activate"}
                      </button>
                      <button className="btn btn-xs btn-warn">Test</button> */}

                      <button
                        className="btn btn-xs"
                        onClick={() => openEditApiModal(api.smsApiId)}
                      >
                        Edit
                      </button>
                      <button
                        className={`btn btn-xs ${api.isActive ? "btn-danger" : "btn-success"}`}
                        onClick={() => handleToggleApi(api.smsApiId)}
                        disabled={apiTogglingId === api.smsApiId}
                      >
                        {api.isActive ? "Deactivate" : "Activate"}
                      </button>

                      <button
                        className="btn btn-xs btn-danger"
                        onClick={() => setDeleteApiId(api.smsApiId)}
                      >
                        🗑
                      </button>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>

          {/* SMS Templates */}
          <div style={{ marginTop: 16 }}>
            <div className="card">
              <div
                className="flex-between mb12"
                style={{ flexWrap: "wrap", gap: 10 }}
              >
                <div>
                  <div className="card-title" style={{ margin: 0 }}>
                    📱 SMS Templates{" "}
                    <span
                      className="badge badge-info"
                      style={{ marginLeft: 6 }}
                    >
                      {smsTemplates.length}
                    </span>
                  </div>
                  <div
                    style={{
                      fontSize: 11,
                      color: "var(--text-secondary)",
                      marginTop: 2,
                    }}
                  >
                    Reusable SMS message bodies. Insert variables like{" "}
                    <code
                      style={{
                        fontFamily: "monospace",
                        background: "var(--bg-secondary)",
                        padding: "1px 4px",
                        borderRadius: 3,
                      }}
                    >
                      {"{{tenant_name}}"}
                    </code>{" "}
                    for personalisation.
                  </div>
                </div>
                <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                  <input
                    type="text"
                    placeholder="🔍 Search sms templates"
                    style={{ fontSize: 12, padding: "6px 10px", width: 200 }}
                  />
                  <button
                    className="btn btn-primary btn-sm"
                    onClick={openAddSmsTplModal}
                  >
                    + Create Template
                  </button>
                </div>
              </div>
              <div style={{ overflowX: "auto" }}>
                <table>
                  <thead>
                    <tr>
                      <th style={{ width: 200 }}>Name</th>
                      <th>Body Preview</th>
                      <th style={{ width: 140 }}>Last Modified</th>
                      <th style={{ width: 140 }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {smsTemplatesLoading ? (
                      Array.from({ length: 3 }).map((_, i) => (
                        <tr key={i}>
                          {Array.from({ length: 4 }).map((_, j) => (
                            <td key={j}>
                              <div
                                style={{
                                  height: 14,
                                  borderRadius: 6,
                                  background:
                                    "linear-gradient(90deg, var(--bg-secondary) 25%, var(--border-light) 50%, var(--bg-secondary) 75%)",
                                  backgroundSize: "200% 100%",
                                  animation: "shimmer 1.4s infinite",
                                  width: "70%",
                                }}
                              />
                            </td>
                          ))}
                        </tr>
                      ))
                    ) : smsTemplates.length === 0 ? (
                      <tr>
                        <td
                          colSpan={4}
                          style={{
                            textAlign: "center",
                            color: "var(--text-tertiary)",
                            padding: 24,
                          }}
                        >
                          No SMS templates found.
                        </td>
                      </tr>
                    ) : (
                      smsTemplates.map((t) => (
                        <tr key={t.templateId}>
                          <td style={{ fontWeight: 600 }}>{t.templateName}</td>
                          <td
                            style={{
                              fontSize: 11,
                              color: "var(--text-secondary)",
                            }}
                          >
                            {t.bodyText?.substring(0, 80)}…
                          </td>
                          <td
                            style={{
                              fontSize: 11,
                              color: "var(--text-tertiary)",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {t.createdAt
                              ? new Date(t.createdAt).toLocaleDateString(
                                  "en-IN",
                                  {
                                    day: "2-digit",
                                    month: "short",
                                    year: "numeric",
                                  },
                                )
                              : "—"}
                          </td>
                          <td style={{ whiteSpace: "nowrap" }}>
                            <div className="td-actions">
                              <span
                                className="action-icon"
                                onClick={() => setPreviewSmsTpl(t)}
                              >
                                <span className="tip">Preview</span>👁
                              </span>
                              <span
                                className="action-icon"
                                onClick={() =>
                                  openEditSmsTplModal(t.templateId)
                                }
                              >
                                <span className="tip">Edit</span>✎
                              </span>
                              <span
                                className="action-icon red"
                                onClick={() => setDeleteSmsTplId(t.templateId)}
                              >
                                <span className="tip">Delete</span>🗑
                              </span>
                              <span
                                className="btn btn-xs"
                                title={t.isActive ? "Activate" : "Deactivate"}
                                style={{
                                  background: t.isActive
                                    ? "var(--green-light, #f0fdf4)"
                                    : "var(--bg-secondary)",
                                  color: t.isActive
                                    ? "var(--green, #16a34a)"
                                    : "var(--text-secondary)",
                                  border: `1px solid ${t.isActive ? "var(--green, #16a34a)" : "var(--red, #e65858)"}`,
                                }}
                                onClick={() =>
                                  handleToggleSmsTemplate(t.templateId)
                                }
                                disabled={togglingId === t.templateId}
                              >
                                {t.isActive ? "✓" : "⊗"}
                              </span>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── Add SMS Template Modal ── */}
      {addSmsTplOpen && (
        <div className="modal-overlay open">
          <div className="modal" style={{ width: 620, maxWidth: "98vw" }}>
            <div className="modal-header">
              <div className="modal-title">📱 Create SMS Template</div>
              <button
                className="modal-close"
                onClick={() => setAddSmsTplOpen(false)}
              >
                ✕
              </button>
            </div>
            <div className="modal-body">
              <div className="form-group mb12">
                <label>Event/Template Name *</label>
                <select
                  value={addSmsTplForm.eventId}
                  onChange={(e) => handleAddSmsTplEventChange(e.target.value)}
                  style={
                    addSmsTplErrors.eventId ? { borderColor: "#dc2626" } : {}
                  }
                >
                  <option value="">— Select Event —</option>
                  {templateEvents.map((ev) => (
                    <option key={ev.eventId} value={ev.eventId}>
                      {ev.eventName}
                    </option>
                  ))}
                </select>
                {addSmsTplErrors.eventId && (
                  <span style={{ color: "#dc2626", fontSize: 11 }}>
                    {addSmsTplErrors.eventId}
                  </span>
                )}
              </div>

              <div className="form-group">
                <label>Message Body *</label>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 6,
                    gap: 8,
                  }}
                >
                  <select
                    value=""
                    onChange={(e) => {
                      if (e.target.value)
                        setAddSmsTplForm((p) => ({
                          ...p,
                          bodyText: p.bodyText + e.target.value,
                        }));
                    }}
                    style={{ fontSize: 11, padding: "4px 6px", width: "auto" }}
                  >
                    <option value="">+ Insert Variable…</option>
                    {smsTemplateVariables.map((v) => (
                      <option key={v.variableId} value={v.placeholder}>
                        {v.placeholder}
                      </option>
                    ))}
                  </select>
                  <span style={{ fontSize: 10, color: "var(--text-tertiary)" }}>
                    {addSmsTplForm.bodyText.length} / 160
                  </span>
                </div>
                <textarea
                  value={addSmsTplForm.bodyText}
                  rows={6}
                  placeholder="Type your SMS message…"
                  maxLength={160}
                  onChange={(e) => {
                    setAddSmsTplForm((p) => ({
                      ...p,
                      bodyText: e.target.value,
                    }));
                    setAddSmsTplErrors((p) => ({ ...p, bodyText: "" }));
                  }}
                  style={{
                    width: "100%",
                    fontFamily: "inherit",
                    fontSize: 13,
                    lineHeight: 1.6,
                    resize: "vertical",
                    ...(addSmsTplErrors.bodyText
                      ? { borderColor: "#dc2626" }
                      : {}),
                  }}
                />
                {addSmsTplErrors.bodyText && (
                  <span style={{ color: "#dc2626", fontSize: 11 }}>
                    {addSmsTplErrors.bodyText}
                  </span>
                )}
                <div
                  style={{
                    fontSize: 10,
                    color: "var(--text-tertiary)",
                    marginTop: 4,
                  }}
                >
                  Plain text only. Keep under 160 chars to fit a single SMS
                  segment.
                </div>
              </div>
              {smsTemplateVariables.length > 0 && (
                <div
                  className="info-box"
                  style={{ marginTop: 12, fontSize: 11 }}
                >
                  <strong>Available variables:</strong>{" "}
                  {smsTemplateVariables.map((v) => (
                    <code
                      key={v.variableId}
                      style={{
                        fontFamily: "monospace",
                        background: "#fff",
                        padding: "1px 5px",
                        borderRadius: 3,
                        border: "0.5px solid var(--border-light)",
                        marginRight: 3,
                      }}
                    >
                      {v.placeholder}
                    </code>
                  ))}
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button className="btn" onClick={() => setAddSmsTplOpen(false)}>
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={handleAddSmsTplSubmit}
                disabled={addSmsTplLoading}
              >
                {addSmsTplLoading ? "Saving..." : "Create Template"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Edit SMS Template Modal ── */}
      {editSmsTplOpen && (
        <div className="modal-overlay open">
          <div className="modal" style={{ width: 620, maxWidth: "98vw" }}>
            <div className="modal-header">
              <div className="modal-title">📱 Edit SMS Template</div>
              <button
                className="modal-close"
                onClick={() => setEditSmsTplOpen(false)}
              >
                ✕
              </button>
            </div>
            <div className="modal-body">
              {editSmsTplFetching ? (
                <div
                  style={{
                    textAlign: "center",
                    padding: "24px 0",
                    color: "var(--text-secondary)",
                    fontSize: 13,
                  }}
                >
                  Loading...
                </div>
              ) : (
                <>
                  <div className="form-group mb12">
                    <label>Event/Template Name *</label>
                    <select
                      value={editSmsTplForm.eventId}
                      onChange={(e) =>
                        handleEditSmsTplEventChange(e.target.value)
                      }
                      style={
                        editSmsTplErrors.eventId
                          ? { borderColor: "#dc2626" }
                          : {}
                      }
                    >
                      <option value="">— Select Event —</option>
                      {templateEvents.map((ev) => (
                        <option key={ev.eventId} value={ev.eventId}>
                          {ev.eventName}
                        </option>
                      ))}
                    </select>
                    {editSmsTplErrors.eventId && (
                      <span style={{ color: "#dc2626", fontSize: 11 }}>
                        {editSmsTplErrors.eventId}
                      </span>
                    )}
                  </div>

                  <div className="form-group">
                    <label>Message Body *</label>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: 6,
                        gap: 8,
                      }}
                    >
                      <select
                        value=""
                        onChange={(e) => {
                          if (e.target.value)
                            setEditSmsTplForm((p) => ({
                              ...p,
                              bodyText: p.bodyText + e.target.value,
                            }));
                        }}
                        style={{
                          fontSize: 11,
                          padding: "4px 6px",
                          width: "auto",
                        }}
                      >
                        <option value="">+ Insert Variable…</option>
                        {smsTemplateVariables.map((v) => (
                          <option key={v.variableId} value={v.placeholder}>
                            {v.placeholder}
                          </option>
                        ))}
                      </select>
                      <span
                        style={{ fontSize: 10, color: "var(--text-tertiary)" }}
                      >
                        {(editSmsTplForm.bodyText || "").length} / 160
                      </span>
                    </div>
                    <textarea
                      value={editSmsTplForm.bodyText}
                      rows={6}
                      maxLength={160}
                      onChange={(e) => {
                        setEditSmsTplForm((p) => ({
                          ...p,
                          bodyText: e.target.value,
                        }));
                        setEditSmsTplErrors((p) => ({ ...p, bodyText: "" }));
                      }}
                      style={{
                        width: "100%",
                        fontFamily: "inherit",
                        fontSize: 13,
                        lineHeight: 1.6,
                        resize: "vertical",
                        ...(editSmsTplErrors.bodyText
                          ? { borderColor: "#dc2626" }
                          : {}),
                      }}
                    />
                    {editSmsTplErrors.bodyText && (
                      <span style={{ color: "#dc2626", fontSize: 11 }}>
                        {editSmsTplErrors.bodyText}
                      </span>
                    )}
                    <div
                      style={{
                        fontSize: 10,
                        color: "var(--text-tertiary)",
                        marginTop: 4,
                      }}
                    >
                      Plain text only. Keep under 160 chars to fit a single SMS
                      segment.
                    </div>
                  </div>
                  {smsTemplateVariables.length > 0 && (
                    <div
                      className="info-box"
                      style={{ marginTop: 12, fontSize: 11 }}
                    >
                      <strong>Available variables:</strong>{" "}
                      {smsTemplateVariables.map((v) => (
                        <code
                          key={v.variableId}
                          style={{
                            fontFamily: "monospace",
                            background: "#fff",
                            padding: "1px 5px",
                            borderRadius: 3,
                            border: "0.5px solid var(--border-light)",
                            marginRight: 3,
                          }}
                        >
                          {v.placeholder}
                        </code>
                      ))}
                    </div>
                  )}
                </>
              )}
            </div>
            {!editSmsTplFetching && (
              <div className="modal-footer">
                <button
                  className="btn"
                  onClick={() => setEditSmsTplOpen(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  onClick={handleEditSmsTplSubmit}
                  disabled={editSmsTplLoading}
                >
                  {editSmsTplLoading ? "Updating..." : "Update Template"}
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      {/* ── Delete SMS Template Modal ── */}
      {deleteSmsTplId && (
        <div className="modal-overlay open">
          <div className="modal" style={{ width: 400, maxWidth: "98vw" }}>
            <div className="modal-header">
              <div className="modal-title">Delete SMS Template</div>
              <button
                className="modal-close"
                onClick={() => setDeleteSmsTplId(null)}
              >
                ✕
              </button>
            </div>
            <div className="modal-body">
              <div style={{ fontSize: 14, marginBottom: 8 }}>
                Are you sure you want to delete this SMS template?
              </div>
              <div style={{ fontSize: 12, color: "var(--text-secondary)" }}>
                This action cannot be undone.
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn" onClick={() => setDeleteSmsTplId(null)}>
                Cancel
              </button>
              <button
                className="btn"
                style={{
                  background: "var(--red, #dc2626)",
                  color: "#fff",
                  border: "none",
                }}
                onClick={handleDeleteSmsTemplate}
                disabled={deleteSmsTplLoading}
              >
                {deleteSmsTplLoading ? "Deleting..." : "🗑 Yes, Delete"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Preview SMS Template Modal ── */}
      {previewSmsTpl && (
        <div
          className="modal-overlay open"
          onClick={() => setPreviewSmsTpl(null)}
        >
          <div className="modal" style={{ width: 480, maxWidth: "98vw" }}>
            <div
              className="modal-header"
              style={{
                background: "var(--blue, #185FA5)",
                borderRadius: "var(--radius-md) var(--radius-md) 0 0",
              }}
            >
              <div className="modal-title" style={{ color: "#fff" }}>
                📱 SMS Preview — {previewSmsTpl.templateName}
              </div>
              <button
                className="modal-close"
                style={{ color: "#fff" }}
                onClick={() => setPreviewSmsTpl(null)}
              >
                ✕
              </button>
            </div>
            <div className="modal-body" style={{ padding: 0 }}>
              <div
                style={{
                  padding: "18px 20px",
                  background: "#f5f5f3",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    background: "#fff",
                    border: "0.5px solid var(--border-light)",
                    borderRadius: "14px 14px 14px 4px",
                    padding: "10px 14px",
                    maxWidth: 300,
                    fontSize: 13,
                    lineHeight: 1.5,
                    boxShadow: "0 1px 2px rgba(0,0,0,0.06)",
                    whiteSpace: "pre-wrap",
                  }}
                >
                  {previewSmsTpl.bodyText}
                </div>
              </div>
              <div
                style={{
                  padding: "10px 18px",
                  background: "var(--bg-secondary)",
                  fontSize: 10,
                  color: "var(--text-tertiary)",
                  textAlign: "center",
                }}
              >
                Preview uses sample values for variables. Real messages
                substitute live tenant/owner data.
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn" onClick={() => setPreviewSmsTpl(null)}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Add API Modal ── */}
      {addApiOpen && (
        <div className="modal-overlay open">
          <div className="modal" style={{ width: 900, maxWidth: "98vw" }}>
            <div className="modal-header">
              <div className="modal-title">New SMS API</div>
              <button
                className="modal-close"
                onClick={() => setAddApiOpen(false)}
              >
                ✕
              </button>
            </div>
            <div
              className="modal-body"
              style={{
                display: "grid",
                gridTemplateColumns: "200px 1fr",
                gap: 0,
                padding: 0,
                minHeight: 500,
              }}
            >
              {/* Left vars panel */}
              <div
                style={{
                  background: "#0F6E56",
                  borderRadius: "0 0 0 var(--radius-lg)",
                  padding: 14,
                  overflowY: "auto",
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    fontWeight: 700,
                    color: "#fff",
                    marginBottom: 3,
                  }}
                >
                  Replacement Values
                </div>
                <div
                  style={{
                    fontSize: 10,
                    color: "rgba(255,255,255,0.6)",
                    textTransform: "uppercase",
                    letterSpacing: ".06em",
                    marginBottom: 10,
                  }}
                >
                  Click to insert into body
                </div>
                {systemVars.map((v) => (
                  <div
                    key={v.varId}
                    onClick={() => insertVarToBody(v.varName, addBodyRef)}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      background: "rgba(0,0,0,0.14)",
                      margin: "2px 0",
                      borderRadius: 5,
                      padding: "7px 10px",
                      cursor: "pointer",
                    }}
                  >
                    <span
                      style={{
                        fontSize: 11,
                        fontWeight: 600,
                        color: "#fff",
                        fontFamily: "monospace",
                      }}
                    >
                      {v.varName}
                    </span>
                    <span
                      style={{ color: "rgba(255,255,255,0.7)", fontSize: 12 }}
                    >
                      📋
                    </span>
                  </div>
                ))}
              </div>
              {/* Right form */}
              <div style={{ padding: 20, overflowY: "auto" }}>
                <div className="form-group mb12">
                  <label>Name *</label>
                  <input
                    type="text"
                    value={addApiForm.name}
                    placeholder="e.g. MSG91 Primary"
                    onChange={(e) => {
                      setAddApiForm((p) => ({ ...p, name: e.target.value }));
                      setAddApiErrors((p) => ({ ...p, name: "" }));
                    }}
                    style={addApiErrors.name ? { borderColor: "#dc2626" } : {}}
                  />
                  {addApiErrors.name && (
                    <span style={{ color: "#dc2626", fontSize: 11 }}>
                      {addApiErrors.name}
                    </span>
                  )}
                </div>
                <div className="form-group mb12">
                  <label>API URL *</label>
                  <textarea
                    value={addApiForm.apiUrl}
                    rows={2}
                    placeholder="Enter full API URL..."
                    style={{
                      minHeight: 52,
                      fontFamily: "monospace",
                      fontSize: 12,
                      lineHeight: "1.6",
                      width: "100%",
                      ...(addApiErrors.apiUrl
                        ? { borderColor: "#dc2626" }
                        : {}),
                    }}
                    onChange={(e) => {
                      setAddApiForm((p) => ({ ...p, apiUrl: e.target.value }));
                      setAddApiErrors((p) => ({ ...p, apiUrl: "" }));
                    }}
                  />
                  {addApiErrors.apiUrl && (
                    <span style={{ color: "#dc2626", fontSize: 11 }}>
                      {addApiErrors.apiUrl}
                    </span>
                  )}
                </div>
                <div className="form-grid mb12">
                  <div className="form-group">
                    <label>Method Type</label>
                    <select
                      value={addApiForm.methodType}
                      onChange={(e) =>
                        setAddApiForm((p) => ({
                          ...p,
                          methodType: e.target.value,
                        }))
                      }
                    >
                      <option>POST</option>
                      <option>GET</option>
                      <option>PUT</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Response Type</label>
                    <select
                      value={addApiForm.responseType}
                      onChange={(e) =>
                        setAddApiForm((p) => ({
                          ...p,
                          responseType: e.target.value,
                        }))
                      }
                    >
                      <option>JSON</option>
                      <option>XML</option>
                      <option>Text</option>
                    </select>
                  </div>
                </div>
                {/* Headers */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: 8,
                  }}
                >
                  <label
                    style={{
                      fontSize: 12,
                      fontWeight: 600,
                      color: "var(--text-secondary)",
                    }}
                  >
                    Dynamic Request Headers
                  </label>
                  <button
                    className="btn btn-xs"
                    onClick={() =>
                      setAddApiForm((p) => ({
                        ...p,
                        headers: [...p.headers, { key: "", value: "" }],
                      }))
                    }
                  >
                    + Add Header
                  </button>
                </div>
                <div style={{ marginBottom: 14 }}>
                  {addApiForm.headers.map((h, idx) => (
                    <div
                      key={idx}
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr 30px",
                        gap: 6,
                        marginBottom: 6,
                        alignItems: "center",
                      }}
                    >
                      <input
                        type="text"
                        value={h.key}
                        placeholder="Header Key e.g. Authorization"
                        style={{ fontSize: 12, fontFamily: "monospace" }}
                        onChange={(e) =>
                          setAddApiForm((p) => {
                            const arr = [...p.headers];
                            arr[idx] = { ...arr[idx], key: e.target.value };
                            return { ...p, headers: arr };
                          })
                        }
                      />
                      <input
                        type="text"
                        value={h.value}
                        placeholder="Value e.g. Bearer YOUR_TOKEN"
                        style={{ fontSize: 12, fontFamily: "monospace" }}
                        onChange={(e) =>
                          setAddApiForm((p) => {
                            const arr = [...p.headers];
                            arr[idx] = { ...arr[idx], value: e.target.value };
                            return { ...p, headers: arr };
                          })
                        }
                      />
                      <button
                        onClick={() =>
                          setAddApiForm((p) => ({
                            ...p,
                            headers: p.headers.filter((_, i) => i !== idx),
                          }))
                        }
                        style={{
                          width: 28,
                          height: 28,
                          border: "0.5px solid #F09595",
                          background: "var(--red-light, #fef2f2)",
                          color: "var(--red, #dc2626)",
                          borderRadius: 5,
                          cursor: "pointer",
                          fontSize: 15,
                          fontFamily: "inherit",
                        }}
                      >
                        ×
                      </button>
                    </div>
                  ))}
                </div>
                {/* Body */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: 6,
                  }}
                >
                  <label
                    style={{
                      fontSize: 12,
                      fontWeight: 600,
                      color: "var(--text-secondary)",
                    }}
                  >
                    Request Body (JSON)
                  </label>
                  <button
                    className="btn btn-xs"
                    onClick={() => {
                      if (addBodyRef.current) {
                        try {
                          addBodyRef.current.value = JSON.stringify(
                            JSON.parse(addBodyRef.current.value),
                            null,
                            2,
                          );
                        } catch {
                          // JSON nahi hai toh silently ignore karo
                        }
                      }
                    }}
                  >
                    Format JSON
                  </button>
                </div>
                <textarea
                  ref={addBodyRef}
                  rows={7}
                  placeholder='{"to":"{TO}","message":"{MESSAGE}"}'
                  style={{
                    width: "100%",
                    minHeight: 150,
                    fontFamily: "monospace",
                    fontSize: 12,
                    lineHeight: "1.6",
                    background: "#1a1a18",
                    color: "#7dd3fc",
                    borderColor: "#333",
                  }}
                />
                <div
                  style={{
                    fontSize: 10,
                    color: "var(--text-tertiary)",
                    marginTop: 4,
                  }}
                >
                  Click any replacement variable on the left to insert at cursor
                </div>
                {/* Schedule */}
                <div
                  style={{
                    marginTop: 14,
                    paddingTop: 12,
                    borderTop: "0.5px solid var(--border-light)",
                  }}
                >
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: 600,
                      color: "var(--text-secondary)",
                      marginBottom: 8,
                    }}
                  >
                    Schedule
                  </div>
                  <div className="form-grid">
                    <div className="form-group">
                      <label>Send Date</label>
                      <input
                        type="date"
                        value={addApiForm.scheduleDate}
                        onChange={(e) =>
                          setAddApiForm((p) => ({
                            ...p,
                            scheduleDate: e.target.value,
                          }))
                        }
                      />
                    </div>
                    <div className="form-group">
                      <label>Send Time</label>
                      <input
                        type="time"
                        value={addApiForm.scheduleTime}
                        onChange={(e) =>
                          setAddApiForm((p) => ({
                            ...p,
                            scheduleTime: e.target.value,
                          }))
                        }
                      />
                    </div>
                  </div>
                  <div className="input-hint" style={{ marginTop: 4 }}>
                    Leave empty to send immediately when triggered
                  </div>
                  <div style={{ marginTop: 12 }}>
                    <label
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        fontSize: 13,
                        cursor: "pointer",
                      }}
                    >
                      <label className="toggle">
                        <input
                          type="checkbox"
                          checked={addApiForm.isActive}
                          onChange={(e) =>
                            setAddApiForm((p) => ({
                              ...p,
                              isActive: e.target.checked,
                            }))
                          }
                        />
                        <span className="toggle-slider" />
                      </label>
                      Active
                    </label>
                  </div>

                  <div className="modal-footer">
                    <button
                      className="btn"
                      onClick={() => setAddApiOpen(false)}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-primary"
                      onClick={handleAddApiSubmit}
                      disabled={addApiLoading}
                    >
                      {addApiLoading ? "Saving..." : "Save API Configuration"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ── Edit API Modal ── */}
      {editApiOpen && (
        <div className="modal-overlay open">
          <div className="modal" style={{ width: 900, maxWidth: "98vw" }}>
            <div className="modal-header">
              <div className="modal-title">Edit SMS API</div>
              <button
                className="modal-close"
                onClick={() => setEditApiOpen(false)}
              >
                ✕
              </button>
            </div>
            {editApiFetching ? (
              <div
                style={{
                  padding: 40,
                  textAlign: "center",
                  color: "var(--text-secondary)",
                }}
              >
                Loading...
              </div>
            ) : (
              <div
                className="modal-body"
                style={{
                  display: "grid",
                  gridTemplateColumns: "200px 1fr",
                  gap: 0,
                  padding: 0,
                  minHeight: 500,
                }}
              >
                {/* Left vars panel */}
                <div
                  style={{
                    background: "#0F6E56",
                    borderRadius: "0 0 0 var(--radius-lg)",
                    padding: 14,
                    overflowY: "auto",
                  }}
                >
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: 700,
                      color: "#fff",
                      marginBottom: 3,
                    }}
                  >
                    Replacement Values
                  </div>
                  <div
                    style={{
                      fontSize: 10,
                      color: "rgba(255,255,255,0.6)",
                      textTransform: "uppercase",
                      letterSpacing: ".06em",
                      marginBottom: 10,
                    }}
                  >
                    Click to insert into body
                  </div>
                  {systemVars.map((v) => (
                    <div
                      key={v.varId}
                      onClick={() => insertVarToBody(v.varName, editBodyRef)}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        background: "rgba(0,0,0,0.14)",
                        margin: "2px 0",
                        borderRadius: 5,
                        padding: "7px 10px",
                        cursor: "pointer",
                      }}
                    >
                      <span
                        style={{
                          fontSize: 11,
                          fontWeight: 600,
                          color: "#fff",
                          fontFamily: "monospace",
                        }}
                      >
                        {v.varName}
                      </span>
                      <span
                        style={{ color: "rgba(255,255,255,0.7)", fontSize: 12 }}
                      >
                        📋
                      </span>
                    </div>
                  ))}
                </div>
                {/* Right form */}
                <div style={{ padding: 20, overflowY: "auto" }}>
                  <div className="form-group mb12">
                    <label>Name *</label>
                    <input
                      type="text"
                      value={editApiForm.name}
                      onChange={(e) => {
                        setEditApiForm((p) => ({ ...p, name: e.target.value }));
                        setEditApiErrors((p) => ({ ...p, name: "" }));
                      }}
                      style={
                        editApiErrors.name ? { borderColor: "#dc2626" } : {}
                      }
                    />
                    {editApiErrors.name && (
                      <span style={{ color: "#dc2626", fontSize: 11 }}>
                        {editApiErrors.name}
                      </span>
                    )}
                  </div>
                  <div className="form-group mb12">
                    <label>API URL *</label>
                    <textarea
                      value={editApiForm.apiUrl}
                      rows={2}
                      style={{
                        minHeight: 52,
                        fontFamily: "monospace",
                        fontSize: 12,
                        lineHeight: "1.6",
                        width: "100%",
                        ...(editApiErrors.apiUrl
                          ? { borderColor: "#dc2626" }
                          : {}),
                      }}
                      onChange={(e) => {
                        setEditApiForm((p) => ({
                          ...p,
                          apiUrl: e.target.value,
                        }));
                        setEditApiErrors((p) => ({ ...p, apiUrl: "" }));
                      }}
                    />
                    {editApiErrors.apiUrl && (
                      <span style={{ color: "#dc2626", fontSize: 11 }}>
                        {editApiErrors.apiUrl}
                      </span>
                    )}
                  </div>
                  <div className="form-grid mb12">
                    <div className="form-group">
                      <label>Method Type</label>
                      <select
                        value={editApiForm.methodType}
                        onChange={(e) =>
                          setEditApiForm((p) => ({
                            ...p,
                            methodType: e.target.value,
                          }))
                        }
                      >
                        <option>POST</option>
                        <option>GET</option>
                        <option>PUT</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label>Response Type</label>
                      <select
                        value={editApiForm.responseType}
                        onChange={(e) =>
                          setEditApiForm((p) => ({
                            ...p,
                            responseType: e.target.value,
                          }))
                        }
                      >
                        <option>JSON</option>
                        <option>XML</option>
                        <option>Text</option>
                      </select>
                    </div>
                  </div>
                  {/* Headers */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginBottom: 8,
                    }}
                  >
                    <label
                      style={{
                        fontSize: 12,
                        fontWeight: 600,
                        color: "var(--text-secondary)",
                      }}
                    >
                      Dynamic Request Headers
                    </label>
                    <button
                      className="btn btn-xs"
                      onClick={() =>
                        setEditApiForm((p) => ({
                          ...p,
                          headers: [...p.headers, { key: "", value: "" }],
                        }))
                      }
                    >
                      + Add Header
                    </button>
                  </div>
                  <div style={{ marginBottom: 14 }}>
                    {(editApiForm.headers || []).map((h, idx) => (
                      <div
                        key={idx}
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr 30px",
                          gap: 6,
                          marginBottom: 6,
                          alignItems: "center",
                        }}
                      >
                        <input
                          type="text"
                          value={h.key}
                          placeholder="Header Key"
                          style={{ fontSize: 12, fontFamily: "monospace" }}
                          onChange={(e) =>
                            setEditApiForm((p) => {
                              const arr = [...p.headers];
                              arr[idx] = { ...arr[idx], key: e.target.value };
                              return { ...p, headers: arr };
                            })
                          }
                        />
                        <input
                          type="text"
                          value={h.value}
                          placeholder="Header Value"
                          style={{ fontSize: 12, fontFamily: "monospace" }}
                          onChange={(e) =>
                            setEditApiForm((p) => {
                              const arr = [...p.headers];
                              arr[idx] = { ...arr[idx], value: e.target.value };
                              return { ...p, headers: arr };
                            })
                          }
                        />
                        <button
                          onClick={() =>
                            setEditApiForm((p) => ({
                              ...p,
                              headers: p.headers.filter((_, i) => i !== idx),
                            }))
                          }
                          style={{
                            width: 28,
                            height: 28,
                            border: "0.5px solid #F09595",
                            background: "var(--red-light, #fef2f2)",
                            color: "var(--red, #dc2626)",
                            borderRadius: 5,
                            cursor: "pointer",
                            fontSize: 15,
                            fontFamily: "inherit",
                          }}
                        >
                          ×
                        </button>
                      </div>
                    ))}
                  </div>
                  {/* Body */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginBottom: 6,
                    }}
                  >
                    <label
                      style={{
                        fontSize: 12,
                        fontWeight: 600,
                        color: "var(--text-secondary)",
                      }}
                    >
                      Request Body (JSON)
                    </label>
                    <button
                      className="btn btn-xs"
                      onClick={() => {
                        if (editBodyRef.current) {
                          try {
                            editBodyRef.current.value = JSON.stringify(
                              JSON.parse(editBodyRef.current.value),
                              null,
                              2,
                            );
                          } catch {
                            // toast.error("Invalid JSON");
                          }
                        }
                      }}
                    >
                      Format JSON
                    </button>
                  </div>
                  <textarea
                    ref={editBodyRef}
                    rows={7}
                    style={{
                      width: "100%",
                      minHeight: 150,
                      fontFamily: "monospace",
                      fontSize: 12,
                      lineHeight: "1.6",
                      background: "#1a1a18",
                      color: "#7dd3fc",
                      borderColor: "#333",
                    }}
                  />
                  <div
                    style={{
                      fontSize: 10,
                      color: "var(--text-tertiary)",
                      marginTop: 4,
                    }}
                  >
                    Click any replacement variable on the left to insert at
                    cursor
                  </div>
                  {/* Schedule */}
                  <div
                    style={{
                      marginTop: 14,
                      paddingTop: 12,
                      borderTop: "0.5px solid var(--border-light)",
                    }}
                  >
                    <div
                      style={{
                        fontSize: 12,
                        fontWeight: 600,
                        color: "var(--text-secondary)",
                        marginBottom: 8,
                      }}
                    >
                      Schedule
                    </div>
                    <div className="form-grid">
                      <div className="form-group">
                        <label>Send Date</label>
                        <input
                          type="date"
                          value={editApiForm.scheduleDate}
                          onChange={(e) =>
                            setEditApiForm((p) => ({
                              ...p,
                              scheduleDate: e.target.value,
                            }))
                          }
                        />
                      </div>
                      <div className="form-group">
                        <label>Send Time</label>
                        <input
                          type="time"
                          value={editApiForm.scheduleTime}
                          onChange={(e) =>
                            setEditApiForm((p) => ({
                              ...p,
                              scheduleTime: e.target.value,
                            }))
                          }
                        />
                      </div>
                    </div>
                    <div className="input-hint" style={{ marginTop: 4 }}>
                      Leave empty to send immediately when triggered
                    </div>
                    <div style={{ marginTop: 12 }}>
                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                          fontSize: 13,
                          cursor: "pointer",
                        }}
                      >
                        <label className="toggle">
                          <input
                            type="checkbox"
                            checked={editApiForm.isActive}
                            onChange={(e) =>
                              setEditApiForm((p) => ({
                                ...p,
                                isActive: e.target.checked,
                              }))
                            }
                          />
                          <span className="toggle-slider" />
                        </label>
                        Active
                      </label>
                    </div>

                    {!editApiFetching && (
                      <div className="modal-footer">
                        <button
                          className="btn"
                          onClick={() => setEditApiOpen(false)}
                        >
                          Cancel
                        </button>
                        <button
                          className="btn btn-primary"
                          onClick={handleEditApiSubmit}
                          disabled={editApiLoading}
                        >
                          {editApiLoading
                            ? "Updating..."
                            : "Update API Configuration"}
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* ── Delete API Modal ── */}
      {deleteApiId && (
        <div className="modal-overlay open">
          <div className="modal" style={{ width: 400, maxWidth: "98vw" }}>
            <div className="modal-header">
              <div className="modal-title">Delete SMS API</div>
              <button
                className="modal-close"
                onClick={() => setDeleteApiId(null)}
              >
                ✕
              </button>
            </div>
            <div className="modal-body">
              <div style={{ fontSize: 14, marginBottom: 8 }}>
                Are you sure you want to delete this SMS API configuration?
              </div>
              <div style={{ fontSize: 12, color: "var(--text-secondary)" }}>
                This action cannot be undone.
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn" onClick={() => setDeleteApiId(null)}>
                Cancel
              </button>
              <button
                className="btn"
                style={{
                  background: "var(--red, #dc2626)",
                  color: "#fff",
                  border: "none",
                }}
                onClick={handleDeleteApi}
                disabled={deleteApiLoading}
              >
                {deleteApiLoading ? "Deleting..." : "🗑 Yes, Delete"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
